import { Div, DivProps, List, ListItem, P } from '@kizi/core-components';
import {
  IconV2 as Icon,
  IconV2Props,
  Rating,
  withTooltip,
  TooltipPosition,
} from '@kizi/shared-components';
import React from 'react';

export type TooltipComponentProps<P> = P & {
  _tooltip: React.ReactNode;
  _popTo?: TooltipPosition;
  _popoverProps?: any;
  _eventType?: 'click' | 'hover';
  onOutsideClick?: Function;
  fieldName?: string;
  trackTooltipClick?: (fieldName: string) => void;
};

const TooltipIcon = withTooltip<IconV2Props>(Icon);

export interface ReviewRowProps extends DivProps {
  name: string;
  tooltip?: TooltipComponentProps<IconV2Props>['_tooltip'];
  score: number;
}

export const ReviewRow: React.FC<ReviewRowProps> = ({
  name,
  tooltip,
  score,
}) => {
  return (
    <Div
      display="flex"
      justifyContent={['space-between', 'flex-start']}
      width="100%"
    >
      <P variant="bodyRegular" width={['50%', '40%']}>
        {name}
      </P>
      <Rating
        disabled
        disabledColor="rating"
        iconProps={{ name: 'star', size: 16, fill: 'rating', mr: 1 }}
        value={score / 2}
      />
      {tooltip && (
        <TooltipIcon
          ml={[null, 60]}
          position="relative"
          bottom="1px"
          name="info"
          size={18}
          css={{ fill: 'main.1' }}
          _tooltip={tooltip}
          cursor="pointer"
          _popTo="top-start"
        />
      )}
    </Div>
  );
};

export interface ReviewCriteriaTableProps extends DivProps {
  ratings: ReviewRowProps[];
}

export const ReviewCriteriaTable: React.FC<ReviewCriteriaTableProps> =
  React.forwardRef<HTMLDivElement, ReviewCriteriaTableProps>(
    ({ ratings, ...divProps }, ref) => {
      return (
        <Div display="flex" flexDirection="column" ref={ref} {...divProps}>
          <List variant="primary">
            {ratings.map((criteria, index) => {
              return (
                <ListItem key={`review-criteria-${index}`}>
                  <ReviewRow {...criteria} />
                </ListItem>
              );
            })}
          </List>
        </Div>
      );
    },
  );
